import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Box, Stack, Typography} from '@mui/material';
import {common} from '../../common/common';
import {useRef} from 'react';
import axios from 'axios';
import {constance} from '../../common/constance/constance';
import {RootState} from '../../reducer';
import {useSelector} from 'react-redux';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {styles} from '../../common/style';
import {isMobile} from 'react-device-detect';
import {NoteHistory} from "../../interface/noteHistory.interface";
import DeleteIcon from "@mui/icons-material/Delete";

type CreateReplyType = {
    user: string,
    post: string,
    content: string,
    id: string,
}

export default function NoteContentDialog(props: { noteHistory: NoteHistory, state: any, setState: any, type: string, deleteNote: any }) {
    console.log('[NoteContentDialog]');

    const handleClose = () => {
        props.setState({
            ...props.state,
            openContent: false,
        });
    };
    let contentRef: any = useRef();

    function handleDeleteNote() {
        props.deleteNote([props.noteHistory._id]);
    }


    return (
        <div>
            <Dialog open={props.state.openContent} onClose={handleClose} sx={{maxHeight: '100vh'}}>
                <DialogTitle>
                    <Box sx={{
                        display: 'flex', flexDirection: {xs: 'column', sm: 'column', md: 'row'},
                        width: 1, background: 'rgba(234,234,234,0.6)', p: 1.5, borderRadius: 2
                    }}>
                        <Box sx={{display: 'flex', width: {xs: 1, sm: 1, md: 0.5}}}>
                            <Typography variant={'subtitle1'} sx={{mr: 1, fontWeight: 'bold'}}>
                                {props.type == constance.noteType.sentInbox ? '받는사람' : '보낸사람'}
                            </Typography>
                            <Typography variant={'subtitle1'}>
                                {
                                    props.type == constance.noteType.sentInbox ?
                                        `${props.noteHistory.receiver.departmentName} ${props.noteHistory.receiver.name}`
                                        :
                                        `${props.noteHistory.sender.departmentName} ${props.noteHistory.sender.name}`
                                }
                            </Typography>
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            width: {xs: 1, sm: 1, md: 0.5},
                            justifyContent: {xs: 'flex-start', sm: 'flex-start', md: 'flex-end'}
                        }}>
                            <Typography variant={'subtitle1'} sx={{mr: 1, fontWeight: 'bold'}}>
                                {props.type == constance.noteType.sentInbox ? '보낸날짜' : '받은날짜'}
                            </Typography>
                            <Typography variant={'subtitle1'}>
                                {`${common.getTimeFormat(props.noteHistory.createdAt)}`}
                            </Typography>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent ref={contentRef}>
                    <DialogContentText>
                        <Stack sx={{width: {xs: 250, sm: 400, md: 500}, mt: 2, p: {xs: 0, sm: 0, md: 2}}}>
                            <Typography
                                className={'textHidden'}
                                dangerouslySetInnerHTML={{
                                    __html: `${props.noteHistory.content}`,
                                }}
                                sx={{
                                    flexGrow: 1,
                                    maxWidth: {xs: 1, sm: 1, md: 0.6},
                                    mb: 0.5, mt: 0.5, pl: 1,
                                    '>p': {
                                        margin: 0,
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'pre-wrap',
                                    },
                                    'p>img': {
                                        maxWidth: 1,
                                    },
                                    minHeight: props.noteHistory.type == constance.noteType.appreciation ? 300 : 1,
                                    ...props.noteHistory.type == constance.noteType.appreciation ? {
                                        maxWidth: 1,
                                        backgroundImage: 'url("/images/appreciation.png")',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center',
                                        backgroundSize: 'contain',
                                    } : {}
                                }}>
                            </Typography>
                        </Stack>
                    </DialogContentText>

                </DialogContent>
                <DialogActions>
                    <Box sx={{display: 'flex', width: 1, position: 'relative', p: 2}}>
                        <Box sx={{flexGrow: 1, display: 'flex', justifyContent: 'center'}}>
                            <Button variant={'contained'}
                                    color={'error'}
                                    onClick={() => handleDeleteNote()}
                            >
                                <DeleteIcon/>
                                <Typography>삭제</Typography>
                            </Button>
                        </Box>

                        <Box sx={{position: 'absolute', right: 16}}>
                            <Button variant={"outlined"} color={"neutral"} onClick={handleClose}>닫기</Button>
                        </Box>

                    </Box>


                </DialogActions>
            </Dialog>
        </div>
    );
}